module.exports = __webpack_public_path__ + "img/icone-quebra.eb3a0cc1.svg";